import { gql } from "@apollo/client";

export const EXTERNAL_REFERENCES_QUERY = gql`
  query externalReferences($scenarioId: ID!, $originId: ID, $crn: String!, $term: String!) {
    data(scenarioId: $scenarioId, originId: $originId) {
      externalReferences(crn: $crn, term: $term) {
        referenceKey
        groupNumber
        capacity
        enrollmentCount
        isActive
        subject {
          name
          nameEnglish
          code
          courseNumber
          key
          type
        }
        campus {
          code
          description
        }
        term {
          code
          description
          startDate
          endDate
        }
      }
    }
  }
`;
